import type { SupplierInstallationEmissionReportProductionRoute } from '../supplierInstallationEmissionReport/productionRoute'

/** Must stay in sync with Prisma `SourceGroupType` enum (see server parity test). */
export const SOURCE_GROUP_TYPES = [
  'INTERNAL',
  'EXTERNAL_COUNTRY_KNOWN',
  'EXTERNAL_INSTALLATION_KNOWN',
  'UNKNOWN',
] as const

export type SourceGroupType = (typeof SOURCE_GROUP_TYPES)[number]

export type SourceGroupProductionRoute =
  SupplierInstallationEmissionReportProductionRoute

export type SourceGroupFieldInput = {
  type: SourceGroupType
  description?: string | null
  country?: string | null
  supplierInstallationId?: string | null
}

export type NormalizedSourceGroupFields = {
  type: SourceGroupType
  description: string | null
  country: string | null
  supplierInstallationId: string | null
}

export type SourceGroupCreateData = {
  installationPrecursorCnCodeId: string
  specificEmbeddedEmissions: number | null
  productionRoute: SourceGroupProductionRoute | null
} & NormalizedSourceGroupFields

export type SourceGroupCreatePayload = NormalizedSourceGroupFields & {
  supplierInstallationEmissionReportId?: string
}
